import { PapiDeviation } from '@wix/da-papi-types';
import React from 'react';
import classnames from 'classnames';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import Dumbo from '../../Dumbo';
import FooterPanel, { FOOTER_PANEL_HEIGHT } from '../../Helper/FooterPanel';
import StackOverlay from './_partials/StackOverlay';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './Stack.scss';

const STACK_INDICATOR_HEIGHT = parseInt(s['stack-indicator-height']);

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  className?: string;
  url?: string;
  // used in grids for dynamic positioning to not wrap every item in a container
  style?: Pick<
    React.CSSProperties,
    'position' | 'top' | 'right' | 'bottom' | 'left' | 'float' | 'margin' | 'width' | 'height'
  >;
  biData?: BiEvent;
  /** used to show a remove button */
  onRemove?: () => void;
  onClick?: () => void;
}

const Stack: React.FC<Props> = ({
  deviation,
  width,
  height,
  className,
  url,
  style,
  biData,
  onRemove,
  onClick,
}) => {
  const dumboHeight = height ? height - (FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT) : undefined;

  const linkAsWrapper = [DeviationTypes.IMAGE, DeviationTypes.FILM, DeviationTypes.PDF].includes(
    getDeviationType(deviation)
  );

  return (
    <div
      className={classnames(s['root'], deviation.hasNewContent && s['unread'], className)}
      style={{ ...style, width, height }}
    >
      <div className={s['stack-indicator']}>
        <div className={s['stack-indicator-inner']} />
      </div>
      <div className={s['content-wrapper']}>
        {linkAsWrapper && (
          <PlainButtonOrLink className={s['content']} href={url} onClick={onClick} biData={biData}>
            <Dumbo deviation={deviation} width={width} height={dumboHeight} />
          </PlainButtonOrLink>
        )}
        {!linkAsWrapper && (
          <div className={s['content']}>
            <Dumbo deviation={deviation} width={width} height={dumboHeight} />
            <PlainButtonOrLink
              href={url}
              onClick={onClick}
              className={s['link-overlay']}
              biData={biData}
            />
          </div>
        )}
        <StackOverlay
          deviation={deviation}
          url={url}
          onRemove={onRemove}
          onClick={onClick}
          biData={biData}
          className={s['overlay']}
        />
        <FooterPanel deviation={deviation} />
      </div>
    </div>
  );
};
Stack.displayName = 'StackThumb';

export default Stack;
export const SIZE_ADJUSTMENTS = FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT;
